// Developer Platform (admin-portal) — platform-wide view of tenant API clients
// from auth-service via the gateway. Read-only: client SECRETS are never
// returned by this endpoint, only metadata (clientId is the public identifier).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

// ---- API clients (per-tenant machine credentials) ----
export interface DeveloperClient {
  id: string;
  tenantId: string;
  name: string;
  clientId: string;
  scopes: string[];
  environment: string; // 'sandbox' | 'production'
  status: string; // 'active' | 'disabled'
  rateLimitPerMin: number;
  lastUsedAt: string | null;
  createdAt: string;
}

export interface DeveloperClientsResponse {
  clients: DeveloperClient[];
}

export const getPlatformClients = () =>
  axios
    .get<DeveloperClientsResponse>(`${API_V1}/developer/platform/clients`)
    .then((r) => r.data);

// Cross-tenant webhook delivery health (event-processor platform endpoint).
export interface WebhookHealth {
  subscriptions: { total: number; active: number; failing: number; disabled: number };
  deliveries: { dead_7d: number; failed_7d: number };
  unhealthy_tenants: { tenant_id: string; failing: number; disabled: number }[];
}

export const getWebhookHealth = () =>
  axios.get<WebhookHealth>(`${API_V1}/webhooks-admin/platform/health`).then((r) => r.data);
